module.exports = __webpack_public_path__ + "img/head_sculpture.84277543.png";